import React from 'react';
import { useFormikContext, getIn } from 'formik';
import { lookupsJson } from '@ourbranch/lookups';
import Field from 'core/components/form/form.v2';

const electricalServiceOptions = lookupsJson.farm.electricalService;
const electricalTypesOptions = lookupsJson.farm.electricalType;
const heatingTypeOptions = lookupsJson.farm.heatingType;

const RenovationFieldsForm = ({ basePath, disabled, checkboxXs = 12, onFieldChange }) => {
  const { values = {}, initialValues = {} } = useFormikContext() || {};
  const buildingPath = `${basePath}.building`;
  const renovationPath = `${buildingPath}.renovation`;
  const areasUnderConstruction = getIn(values, `${buildingPath}.areasUnderConstruction`);
  const initialBuilding = getIn(initialValues, `${basePath}.building`);
  const initialRenovation = initialBuilding?.renovation;

  const makeOnChange = (initialValue) => {
    if (!onFieldChange) {
      return undefined;
    }
    return (val) => {
      if (val !== initialValue) {
        onFieldChange();
      }
    };
  };

  return (
    <>
      <Field
        xs={checkboxXs}
        type="checkbox"
        id={`${buildingPath}.areasUnderConstruction`}
        name={`${buildingPath}.areasUnderConstruction`}
        mode="light"
        label="Renovations"
        disabled={disabled}
        onChange={makeOnChange(initialBuilding?.areasUnderConstruction)}
      />
      {areasUnderConstruction && (
        <>
          <Field
            xs={4}
            id={`${renovationPath}.electricalType`}
            name={`${renovationPath}.electricalType`}
            type="select"
            options={electricalTypesOptions}
            mode="light"
            label="Electrical Type"
            disabled={disabled}
            onChange={makeOnChange(initialRenovation?.electricalType)}
          />
          <Field
            xs={4}
            id={`${renovationPath}.electricalService`}
            name={`${renovationPath}.electricalService`}
            type="select"
            options={electricalServiceOptions}
            mode="light"
            label="Electrical Service Update"
            disabled={disabled}
            onChange={makeOnChange(initialRenovation?.electricalService)}
          />
          <Field
            xs={4}
            id={`${renovationPath}.heatingType`}
            name={`${renovationPath}.heatingType`}
            type="select"
            options={heatingTypeOptions}
            mode="light"
            label="Heating Type"
            disabled={disabled}
            onChange={makeOnChange(initialRenovation?.heatingType)}
          />
          <Field
            xs={3}
            type="numeric"
            id={`${renovationPath}.heatingYear`}
            name={`${renovationPath}.heatingYear`}
            mode="light"
            label="Heating Year"
            disabled={disabled}
            onChange={makeOnChange(initialRenovation?.heatingYear)}
          />
          <Field
            xs={3}
            type="numeric"
            id={`${renovationPath}.coolingYear`}
            name={`${renovationPath}.coolingYear`}
            mode="light"
            label="AC Year"
            disabled={disabled}
            onChange={makeOnChange(initialRenovation?.coolingYear)}
          />
          <Field
            xs={3}
            type="numeric"
            id={`${renovationPath}.plumbingYear`}
            name={`${renovationPath}.plumbingYear`}
            mode="light"
            label="Plumbing Year"
            disabled={disabled}
            onChange={makeOnChange(initialRenovation?.plumbingYear)}
          />
          <Field
            xs={3}
            type="numeric"
            id={`${renovationPath}.electricalYear`}
            name={`${renovationPath}.electricalYear`}
            mode="light"
            label="Electrical Year"
            disabled={disabled}
            onChange={makeOnChange(initialRenovation?.electricalYear)}
          />
        </>
      )}
    </>
  );
};

export default RenovationFieldsForm;
